var URI = require('urijs');

export function getGameUrl(url) {
    let uri = new URI();

    return uri.path('/game').fragment(url).href();
}

export function getAdminUrl(url) {
    let uri = new URI();

    return uri.path('/admin').fragment(url).href();
}
